// Экспорт основных конфигураций
export { siteConfig } from './site-config';
export type { 
    SiteConfig, 
    LanguageConfig, 
    SiteFeature, 
    SiteFeatures,
    SiteMetadata,
    ContactInfo,
    AuthFeatureConfig,
    AuthMethod
} from './site-config';

export { languageData } from './language-data';
export type { 
    LanguageData, 
    NavigationItem, 
    FooterSection 
} from './language-data';

// Экспорт утилит
export {
    getLanguageConfig,
    getDefaultLanguage,
    getEnabledLanguages,
    getLanguageFromPath,
    getLanguageData,
    buildLanguagePath,
    isFeatureEnabled,
    getFeatureConfig,
    getEnabledFeatures,
    getLanguageMetadata,
    getLanguageContactInfo,
    getLanguageCurrency,
    getTranslation,
    getFormTranslation,
    getNavigationData,
    getApiConfig,
    getCacheConfig,
    getGeneralConfig,
    getSeoConfig,
    getAuthFeatureConfig,
    useConfig
} from './utils';

// Экспорт компонентов для условного рендеринга
export { 
    FeatureGuard, 
    MultiFeatureGuard,
    useFeature,
    useFeatures
} from './FeatureGuard';

// Экспорт хуков и компонентов для работы с языками
export { 
    useLanguage,
    useLanguageStatic,
    LanguageSwitcher,
    TranslatedText
} from './useLanguage';

// Утилиты для получения констант (используют уже импортированный siteConfig из utils)
export { getEnabledLanguages as getEnabledLanguagesConfig } from './utils';
export { getDefaultLanguage as getDefaultLanguageConfig } from './utils';

// Типы для удобства
export type FeatureName = 
    | 'shop' 
    | 'blog' 
    | 'auth' 
    | 'search' 
    | 'cart' 
    | 'wishlist' 
    | 'reviews' 
    | 'notifications' 
    | 'analytics' 
    | 'chatbot' 
    | 'multiCurrency' 
    | 'socialLogin' 
    | 'newsletter' 
    | 'sms';

export type LanguageCode = 'en' | 'ru' | 'de'; 
